import { render, staticRenderFns } from "./star-poster.vue?vue&type=template&id=85f301c8"
import script from "./star-poster.vue?vue&type=script&lang=js"
export * from "./star-poster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports